import { EventStatus } from "app/utils/const";
import React from "react";
const SuspendedTextEvent = (props: {
  event: {
    status: string;
  };
}): React.JSX.Element => {
  return (
    (props.event.status === EventStatus.SUSPENDED ||
      props.event.status === EventStatus.CLOSED ||
      props.event.status === EventStatus.GRADED) && (
      <div className="suspended__text--event">
        {props.event.status === EventStatus.CLOSED ||
        props.event.status === EventStatus.GRADED
          ? "Closed"
          : "Suspended"}
      </div>
    )
  );
};

export default SuspendedTextEvent;
